

// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   Check, Play, Users, Package, BarChart3, Globe, Shield, Zap,
//   ArrowRight, Menu, X, Star, TrendingUp, Clock, CheckCircle,
//   Wifi, WifiOff, Smartphone, Database, RefreshCw, ChevronDown
// } from 'lucide-react';
// import './LandingPage.css';

// const PLANS = {
//   starter: {
//     name: 'Starter',
//     price: { usd: 29, eur: 27, tzs: 67000, ugx: 108000 },
//     perpetual: { usd: 290, eur: 270, tzs: 670000, ugx: 1080000 },
//     features: ['Up to 5 users', '2 warehouses', '2 devices', 'Basic reporting', 'Email support', 'Offline mode', 'Mobile access'],
//     popular: false
//   },
//   business: {
//     name: 'Business',
//     price: { usd: 79, eur: 75, tzs: 182000, ugx: 295000 },
//     perpetual: { usd: 790, eur: 750, tzs: 1820000, ugx: 2950000 },
//     features: ['Up to 15 users', '5 warehouses', '5 devices', 'Advanced analytics', 'Priority support', 'Offline mode', 'Mobile access', 'Stock predictions', 'Custom reports'],
//     popular: true
//   },
//   professional: {
//     name: 'Professional',
//     price: { usd: 199, eur: 189, tzs: 460000, ugx: 745000 },
//     perpetual: { usd: 1990, eur: 1890, tzs: 4600000, ugx: 7450000 },
//     features: ['Unlimited users', 'Unlimited warehouses', '10 devices', 'Advanced analytics', 'Dedicated support', 'Offline mode', 'Mobile access', 'AI predictions', 'Custom reports', 'API access', 'White-label option'],
//     popular: false
//   }
// };

// const STATS = [
//   { value: '500+', label: 'Businesses', sub: 'across 6 countries' },
//   { value: '99.9%', label: 'Uptime', sub: 'even offline' },
//   { value: '15hrs', label: 'Saved weekly', sub: 'per business' },
//   { value: '2 min', label: 'Setup time', sub: 'to first stock entry' },
// ];

// const FEATURES = [
//   { icon: <WifiOff size={28} />, title: 'Works Without Internet', desc: 'Power cuts. Weak signal. Remote warehouse. TaalumaERP keeps running. Your data syncs automatically the moment you reconnect.', highlight: 'Built for Africa' },
//   { icon: <Package size={28} />, title: 'Multi-Warehouse Control', desc: 'Track stock across Dar es Salaam, Kampala, and Milan from one dashboard. Transfer inventory, get low-stock alerts, never oversell.', highlight: 'Real-time' },
//   { icon: <BarChart3 size={28} />, title: 'AI-Powered Insights', desc: 'Know which products make you money, which customers to focus on, and what to restock before you run out.', highlight: 'Smart' },
//   { icon: <Users size={28} />, title: 'Team & Permissions', desc: 'Add warehouse staff, managers, admins. Each person sees only what they need. Full audit trail of every action.', highlight: 'Secure' },
//   { icon: <Smartphone size={28} />, title: 'Any Device, Anywhere', desc: 'Phone, tablet, laptop. Scan barcodes, create orders, check stock — from the warehouse floor or your office in Europe.', highlight: 'Mobile-first' },
//   { icon: <Shield size={28} />, title: 'Enterprise Security', desc: 'Device tracking, role-based access, encrypted data. Know exactly who accessed what and when.', highlight: 'Trusted' },
// ];

// const TESTIMONIALS = [
//   { name: 'Amina Hassan', company: 'East African Traders Ltd', country: '🇹🇿 Dar es Salaam', text: 'We have 3 warehouses and before TaalumaERP we were using WhatsApp and spreadsheets. Now everything is in one place. The offline mode saved us during the power cuts last month.', rating: 5 },
//   { name: 'Marco Rigon', company: 'Ethnic World Import/Export', country: '🇮🇹 Modena, Italy', text: 'We import from Tanzania and Uganda. Having our suppliers on the same system as our warehouse here in Italy changed everything. Stock visibility across continents.', rating: 5 },
//   { name: 'David Otieno', company: 'Kampala Wholesale Supplies', country: '🇺🇬 Kampala', text: 'The price is right for African businesses. Not like those European ERPs that cost $500 a month. This does everything we need at a price that makes sense.', rating: 5 },
// ];

// // Simple reveal hook
// function useReveal() {
//   useEffect(() => {
//     const els = document.querySelectorAll('.lp-reveal');
    
//     if (!window.IntersectionObserver) {
//       // Fallback: just show everything
//       els.forEach(el => el.classList.add('lp--visible'));
//       return;
//     }

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add('lp--visible');
//             observer.unobserve(entry.target);
//           }
//         });
//       },
//       { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
//     );

//     els.forEach(el => observer.observe(el));
//     return () => observer.disconnect();
//   }, []);
// }

// function LandingPage() {
//   const navigate = useNavigate();
//   const [selectedCurrency, setSelectedCurrency] = useState('eur');
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const [showVideoModal, setShowVideoModal] = useState(false);
//   const [billingType, setBillingType] = useState('monthly');

//   useReveal();

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   useEffect(() => {
//     const handleEscape = (e) => { if (e.key === 'Escape') setShowVideoModal(false); };
//     window.addEventListener('keydown', handleEscape);
//     return () => window.removeEventListener('keydown', handleEscape);
//   }, []);

//   const formatPrice = (price, currency) => {
//     const symbols = { usd: '$', eur: '€', tzs: 'TSh ', ugx: 'UGX ' };
//     if (currency === 'tzs' || currency === 'ugx') {
//       return `${symbols[currency]}${price >= 1000 ? (price / 1000).toFixed(0) + 'K' : price.toLocaleString()}`;
//     }
//     return `${symbols[currency]}${price.toLocaleString()}`;
//   };

//   const scrollToSection = (id) => {
//     document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
//     setIsMenuOpen(false);
//   };

//   return (
//     <div className="lp">

//       {/* NAV */}
//       <nav className={`lp-nav ${scrolled ? 'lp-nav--scrolled' : ''}`}>
//         <div className="lp-nav__inner">
//           <div className="lp-nav__brand" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
//             <span className="lp-nav__logo">⬡</span>
//             <span className="lp-nav__name">TaalumaERP</span>
//           </div>
//           <div className="lp-nav__links">
//             {['features', 'how-it-works', 'pricing', 'testimonials'].map(id => (
//               <button key={id} onClick={() => scrollToSection(id)} className="lp-nav__link">
//                 {id.replace('-', ' ').replace(/\b\w/g, c => c.toUpperCase())}
//               </button>
//             ))}
//             <button onClick={() => navigate('/login')} className="lp-nav__login">Sign In</button>
//             <button onClick={() => navigate('/register')} className="lp-nav__cta">Start Free →</button>
//           </div>
//           <button className="lp-nav__hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
//             {isMenuOpen ? <X size={22} /> : <Menu size={22} />}
//           </button>
//         </div>
//         {isMenuOpen && (
//           <div className="lp-mobile-menu">
//             {['features', 'how-it-works', 'pricing', 'testimonials'].map(id => (
//               <button key={id} onClick={() => scrollToSection(id)} className="lp-mobile-menu__link">
//                 {id.replace('-', ' ').replace(/\b\w/g, c => c.toUpperCase())}
//               </button>
//             ))}
//             <button onClick={() => navigate('/register')} className="lp-mobile-menu__cta">Start Free Trial →</button>
//           </div>
//         )}
//       </nav>

//       {/* HERO */}
//       <section className="lp-hero">
//         <div className="lp-hero__bg">
//           <div className="lp-hero__grid"></div>
//           <div className="lp-hero__glow lp-hero__glow--1"></div>
//           <div className="lp-hero__glow lp-hero__glow--2"></div>
//         </div>
//         <div className="lp-hero__inner">
//           <div className="lp-hero__content">
//             <div className="lp-hero__badge">
//               <span className="lp-hero__badge-dot"></span>
//               Built for East Africa · Used in Europe
//             </div>
//             <h1 className="lp-hero__title">
//               Run Your Business.<br />
//               <span className="lp-hero__title-accent">With or Without Internet.</span>
//             </h1>
//             <p className="lp-hero__sub">
//               Inventory, orders, warehouses and team — all in one system that works even when the power goes out or the signal drops. Trusted by businesses from Kampala to Milan.
//             </p>
//             <div className="lp-hero__actions">
//               <button onClick={() => navigate('/register')} className="lp-btn-primary">
//                 Start 14-Day Free Trial <ArrowRight size={18} />
//               </button>
//               <button onClick={() => setShowVideoModal(true)} className="lp-btn-ghost">
//                 <div className="lp-btn-ghost__play"><Play size={14} /></div>
//                 Watch Demo
//               </button>
//             </div>
//             <div className="lp-hero__trust">
//               <CheckCircle size={16} /><span>No credit card</span>
//               <span className="lp-hero__trust-sep">·</span>
//               <CheckCircle size={16} /><span>Cancel anytime</span>
//               <span className="lp-hero__trust-sep">·</span>
//               <CheckCircle size={16} /><span>Works offline</span>
//             </div>
//           </div>
//           <div className="lp-hero__visual">
//             <div className="lp-dashboard-mock">
//               <div className="lp-mock__bar">
//                 <span className="lp-mock__dot lp-mock__dot--r"></span>
//                 <span className="lp-mock__dot lp-mock__dot--y"></span>
//                 <span className="lp-mock__dot lp-mock__dot--g"></span>
//                 <span className="lp-mock__title">TaalumaERP — Dashboard</span>
//               </div>
//               <div className="lp-mock__body">
//                 <div className="lp-mock__stats">
//                   {[
//                     { label: 'Total Stock', val: '12,480' },
//                     { label: 'Pending Orders', val: '34' },
//                     { label: 'Low Stock Alert', val: '7' },
//                     { label: 'Revenue', val: 'TSh 4.2M' },
//                   ].map((s, i) => (
//                     <div key={i} className="lp-mock__stat">
//                       <div className="lp-mock__stat-val">{s.val}</div>
//                       <div className="lp-mock__stat-label">{s.label}</div>
//                     </div>
//                   ))}
//                 </div>
//                 <div className="lp-mock__chart">
//                   {[40,65,45,80,55,90,70,85,60,95,75,88].map((h, i) => (
//                     <div key={i} className="lp-mock__bar-item" style={{ height: `${h}%`, animationDelay: `${i * 0.05}s` }}></div>
//                   ))}
//                 </div>
//                 <div className="lp-mock__footer">
//                   <div className="lp-mock__online"><WifiOff size={12} /><span>Offline — syncing when connected</span></div>
//                   <div>3 warehouses active</div>
//                 </div>
//               </div>
//             </div>
//             <div className="lp-hero__float lp-hero__float--1"><RefreshCw size={14} /><span>Synced 2 min ago</span></div>
//             <div className="lp-hero__float lp-hero__float--2"><TrendingUp size={14} /><span>+23% this month</span></div>
//             <div className="lp-hero__float lp-hero__float--3"><Package size={14} /><span>Stock alert: Maize flour</span></div>
//           </div>
//         </div>
//         <div className="lp-hero__scroll" onClick={() => scrollToSection('stats')}><ChevronDown size={20} /></div>
//       </section>

//       {/* STATS */}
//       <section id="stats" className="lp-stats">
//         <div className="lp-stats__inner lp-reveal">
//           {STATS.map((s, i) => (
//             <div key={i} className="lp-stats__item">
//               <div className="lp-stats__val">{s.value}</div>
//               <div className="lp-stats__label">{s.label}</div>
//               <div className="lp-stats__sub">{s.sub}</div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* OFFLINE CALLOUT */}
//       <section className="lp-offline">
//         <div className="lp-offline__inner lp-reveal">
//           <div className="lp-offline__icon-wrap"><WifiOff size={32} /></div>
//           <div className="lp-offline__text">
//             <h2>Built for places where internet isn't guaranteed.</h2>
//             <p>Most ERP systems crash without internet. TaalumaERP was designed from the ground up for East African business reality — power cuts, weak 3G, remote warehouses. Everything works offline. When you reconnect, it syncs automatically. No data loss. No excuses.</p>
//           </div>
//           <div className="lp-offline__badges">
//             <div className="lp-offline__badge"><Wifi size={16} /><span>Auto-sync</span></div>
//             <div className="lp-offline__badge"><Database size={16} /><span>Local storage</span></div>
//             <div className="lp-offline__badge"><Smartphone size={16} /><span>Mobile-first</span></div>
//           </div>
//         </div>
//       </section>

//       {/* FEATURES */}
//       <section id="features" className="lp-features">
//         <div className="lp-features__inner">
//           <div className="lp-section-head lp-reveal">
//             <p className="lp-section-head__eyebrow">What you get</p>
//             <h2 className="lp-section-head__title">Everything your business needs.<br />Nothing you don't.</h2>
//           </div>
//           <div className="lp-features__grid">
//             {FEATURES.map((f, i) => (
//               <div key={i} className="lp-feature-card lp-reveal" style={{ transitionDelay: `${i * 0.07}s` }}>
//                 <div className="lp-feature-card__top">
//                   <div className="lp-feature-card__icon">{f.icon}</div>
//                   <span className="lp-feature-card__pill">{f.highlight}</span>
//                 </div>
//                 <h3 className="lp-feature-card__title">{f.title}</h3>
//                 <p className="lp-feature-card__desc">{f.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* HOW IT WORKS */}
//       <section id="how-it-works" className="lp-how">
//         <div className="lp-how__inner">
//           <div className="lp-section-head lp-reveal">
//             <p className="lp-section-head__eyebrow">Getting started</p>
//             <h2 className="lp-section-head__title">Up and running in under 10 minutes.</h2>
//           </div>
//           <div className="lp-how__steps">
//             {[
//               { n: '01', title: 'Create your account', desc: 'Register your business. No credit card needed. Your 14-day trial starts immediately.' },
//               { n: '02', title: 'Set up warehouses', desc: 'Add your warehouses — whether one room or multiple cities. Assign your team.' },
//               { n: '03', title: 'Import your stock', desc: 'Upload a CSV or add products manually. Bulk import supported for large catalogues.' },
//               { n: '04', title: 'Start managing', desc: 'Create orders, track stock, generate reports. Works on any device, online or offline.' },
//             ].map((step, i) => (
//               <div key={i} className="lp-how__step lp-reveal" style={{ transitionDelay: `${i * 0.1}s` }}>
//                 <div className="lp-how__step-num">{step.n}</div>
//                 <div className="lp-how__step-body">
//                   <h3>{step.title}</h3>
//                   <p>{step.desc}</p>
//                 </div>
//                 {i < 3 && <div className="lp-how__step-arrow">→</div>}
//               </div>
//             ))}
//           </div>
//           <div className="lp-how__cta lp-reveal">
//             <button onClick={() => navigate('/register')} className="lp-btn-primary">
//               Get Started Free <ArrowRight size={18} />
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* TESTIMONIALS */}
//       <section id="testimonials" className="lp-testimonials">
//         <div className="lp-testimonials__inner">
//           <div className="lp-section-head lp-reveal">
//             <p className="lp-section-head__eyebrow">Real customers</p>
//             <h2 className="lp-section-head__title">From Kampala to Milan.<br />Businesses that rely on us daily.</h2>
//           </div>
//           <div className="lp-testimonials__grid">
//             {TESTIMONIALS.map((t, i) => (
//               <div key={i} className="lp-testimonial-card lp-reveal" style={{ transitionDelay: `${i * 0.1}s` }}>
//                 <div className="lp-testimonial-card__stars">
//                   {[...Array(t.rating)].map((_, j) => <Star key={j} size={16} fill="#f59e0b" color="#f59e0b" />)}
//                 </div>
//                 <p className="lp-testimonial-card__text">"{t.text}"</p>
//                 <div className="lp-testimonial-card__author">
//                   <div className="lp-testimonial-card__avatar">{t.name.split(' ').map(n => n[0]).join('')}</div>
//                   <div>
//                     <div className="lp-testimonial-card__name">{t.name}</div>
//                     <div className="lp-testimonial-card__company">{t.company}</div>
//                     <div className="lp-testimonial-card__country">{t.country}</div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* PRICING */}
//       <section id="pricing" className="lp-pricing">
//         <div className="lp-pricing__inner">
//           <div className="lp-section-head lp-reveal">
//             <p className="lp-section-head__eyebrow">Pricing</p>
//             <h2 className="lp-section-head__title">Priced for African businesses.<br />Powerful enough for European ones.</h2>
//           </div>
//           <div className="lp-pricing__controls lp-reveal">
//             <div className="lp-pricing__billing">
//               <button className={`lp-pricing__billing-btn ${billingType === 'monthly' ? 'active' : ''}`} onClick={() => setBillingType('monthly')}>Monthly</button>
//               <button className={`lp-pricing__billing-btn ${billingType === 'onetime' ? 'active' : ''}`} onClick={() => setBillingType('onetime')}>One-time <span className="lp-pricing__billing-save">Save 10x</span></button>
//             </div>
//             <div className="lp-pricing__currencies">
//               {[{ key: 'eur', label: '€ EUR', flag: '🇪🇺' }, { key: 'usd', label: '$ USD', flag: '🇺🇸' }, { key: 'tzs', label: 'TSh', flag: '🇹🇿' }, { key: 'ugx', label: 'UGX', flag: '🇺🇬' }].map(c => (
//                 <button key={c.key} onClick={() => setSelectedCurrency(c.key)} className={`lp-pricing__currency-btn ${selectedCurrency === c.key ? 'active' : ''}`}>
//                   {c.flag} {c.label}
//                 </button>
//               ))}
//             </div>
//           </div>
//           <div className="lp-pricing__cards">
//             {Object.entries(PLANS).map(([key, plan], i) => (
//               <div key={key} className={`lp-pricing-card lp-reveal ${plan.popular ? 'lp-pricing-card--popular' : ''}`} style={{ transitionDelay: `${i * 0.1}s` }}>
//                 {plan.popular && <div className="lp-pricing-card__badge">Most Popular</div>}
//                 <div className="lp-pricing-card__head">
//                   <h3 className="lp-pricing-card__name">{plan.name}</h3>
//                   <div className="lp-pricing-card__price">
//                     <span className="lp-pricing-card__amount">
//                       {billingType === 'monthly' ? formatPrice(plan.price[selectedCurrency], selectedCurrency) : formatPrice(plan.perpetual[selectedCurrency], selectedCurrency)}
//                     </span>
//                     <span className="lp-pricing-card__period">{billingType === 'monthly' ? '/month' : ' one-time'}</span>
//                   </div>
//                   {billingType === 'monthly' && (
//                     <div className="lp-pricing-card__onetime">or {formatPrice(plan.perpetual[selectedCurrency], selectedCurrency)} one-time</div>
//                   )}
//                 </div>
//                 <ul className="lp-pricing-card__features">
//                   {plan.features.map((f, j) => (
//                     <li key={j}><Check size={16} /><span>{f}</span></li>
//                   ))}
//                 </ul>
//                 <button onClick={() => navigate('/register')} className={`lp-pricing-card__btn ${plan.popular ? 'lp-pricing-card__btn--primary' : ''}`}>
//                   Start Free Trial
//                 </button>
//               </div>
//             ))}
//           </div>
//           <p className="lp-pricing__note">All plans include 14-day free trial · No credit card required · Cancel anytime</p>
//         </div>
//       </section>

//       {/* FINAL CTA */}
//       <section className="lp-cta">
//         <div className="lp-cta__inner lp-reveal">
//           <div className="lp-cta__bg"></div>
//           <p className="lp-cta__eyebrow">Ready to grow?</p>
//           <h2 className="lp-cta__title">Stop managing inventory with<br />WhatsApp and spreadsheets.</h2>
//           <p className="lp-cta__sub">Join businesses in Tanzania, Uganda, Kenya, Italy, France and Germany who run smarter operations with TaalumaERP.</p>
//           <button onClick={() => navigate('/register')} className="lp-btn-primary lp-btn-primary--large">
//             Start Your Free Trial Today <ArrowRight size={20} />
//           </button>
//           <div className="lp-cta__countries">🇹🇿 Tanzania &nbsp;·&nbsp; 🇺🇬 Uganda &nbsp;·&nbsp; 🇰🇪 Kenya &nbsp;·&nbsp; 🇮🇹 Italy &nbsp;·&nbsp; 🇫🇷 France &nbsp;·&nbsp; 🇩🇪 Germany</div>
//         </div>
//       </section>

//       {/* FOOTER */}
//       <footer className="lp-footer">
//         <div className="lp-footer__inner">
//           <div className="lp-footer__brand">
//             <span className="lp-footer__logo">⬡ TaalumaERP</span>
//             <p>Professional inventory management that works everywhere.<br />Built for Africa. Trusted in Europe.</p>
//           </div>
//           <div className="lp-footer__links">
//             <a href="/terms">Terms of Service</a>
//             <a href="/privacy">Privacy Policy</a>
//             <a href="mailto:support@taalumaerp.com">Support</a>
//           </div>
//           <p className="lp-footer__copy">© 2025 TaalumaERP · Made with ❤️ in Modena, Italy</p>
//         </div>
//       </footer>

//       {/* VIDEO MODAL */}
//       {showVideoModal && (
//         <div className="lp-video-overlay" onClick={() => setShowVideoModal(false)}>
//           <div className="lp-video-modal" onClick={e => e.stopPropagation()}>
//             <button className="lp-video-modal__close" onClick={() => setShowVideoModal(false)}><X size={20} /></button>
//             <div className="lp-video-modal__placeholder">
//               <Play size={48} />
//               <p>Demo video coming soon</p>
//               <button onClick={() => { setShowVideoModal(false); navigate('/register'); }} className="lp-btn-primary">
//                 Try it yourself instead →
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default LandingPage;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ArrowRight, Check, Play, X, Menu, ChevronRight,
  WifiOff, Package, BarChart3, Users, Shield,
  Smartphone, RefreshCw, TrendingUp, AlertCircle, Lock, Layers
} from 'lucide-react';
import './LandingPage.css';
import ChatBot from '../chatbot';
/* ── DATA ───────────────────────────────────────────────────── */
const PLANS = [
  {
    key:'starter', name:'Starter',
    price:{eur:27,usd:29,tzs:67000,ugx:108000},
    onetime:{eur:270,usd:290,tzs:670000,ugx:1080000},
    limits:'5 users · 2 warehouses · 2 devices',
    features:['Inventory management','Order tracking','Basic reports','Offline mode','Email support'],
  },
  {
    key:'business', name:'Business', popular:true,
    price:{eur:75,usd:79,tzs:182000,ugx:295000},
    onetime:{eur:750,usd:790,tzs:1820000,ugx:2950000},
    limits:'15 users · 5 warehouses · 5 devices',
    features:['Everything in Starter','Advanced analytics','Stock predictions','Custom reports','Priority support'],
  },
  {
    key:'professional', name:'Professional',
    price:{eur:189,usd:199,tzs:460000,ugx:745000},
    onetime:{eur:1890,usd:1990,tzs:4600000,ugx:7450000},
    limits:'Unlimited users & warehouses · 10 devices',
    features:['Everything in Business','AI predictions','API access','White-label option','Dedicated support'],
  },
];

const CURRENCIES=[
  {key:'eur',label:'€ EUR',flag:'🇪🇺'},
  {key:'usd',label:'$ USD',flag:'🇺🇸'},
  {key:'tzs',label:'TSh TZS',flag:'🇹🇿'},
  {key:'ugx',label:'UGX',flag:'🇺🇬'},
];

const FEATURES=[
  {
    icon:<WifiOff size={22}/>, title:'Offline-first architecture', tag:'Core', featured:true,
    body:'Everything — stock lookups, order creation, inventory updates — works without internet. Data syncs automatically when you reconnect. No data loss, ever.',
  },
  {
    icon:<Layers size={22}/>, title:'Multi-warehouse in one view', tag:'Inventory',
    body:'Manage stock across multiple locations from a single dashboard. Transfer inventory between warehouses, track movement, and get unified reporting.',
  },
  {
    icon:<BarChart3 size={22}/>, title:'Reports that tell you something', tag:'Analytics',
    body:'Revenue by product, customer purchase history, stock turnover rates, low-stock predictions. Built for business decisions, not vanity metrics.',
  },
  {
    icon:<Users size={22}/>, title:'Role-based team access', tag:'Teams',
    body:"Admin, manager, or staff — each role sees exactly what it needs. Full audit log of every action. Device tracking so you know who's logged in from where.",
  },
  {
    icon:<Smartphone size={22}/>, title:'Works on any device', tag:'Access',
    body:'Browser-based. Use it on a phone in the warehouse, a tablet at the till, or a laptop in the office. No app installs. No per-device licensing.',
  },
  {
    icon:<Shield size={22}/>, title:'Your data stays yours', tag:'Security',
    body:'Encrypted in transit and at rest. Organization-scoped — your data is never visible to other companies. Export everything at any time.',
  },
];

const METRICS=[
  {val:'14 days', label:'Free trial', sub:'Full access, no card needed'},
  {val:'< 15min', label:'To get started', sub:'From signup to first stock entry'},
  {val:'4', label:'Currencies', sub:'TZS · UGX · EUR · USD'},
  {val:'100%', label:'Offline capable', sub:'Syncs when you reconnect'},
];

function fmt(price, currency) {
  const s={eur:'€',usd:'$',tzs:'TSh ',ugx:'UGX '};
  if(currency==='tzs'||currency==='ugx')
    return `${s[currency]}${price>=1000?(price/1000).toFixed(0)+'K':price}`;
  return `${s[currency]}${price}`;
}

/* ── COMPONENT ──────────────────────────────────────────────── */
export default function LandingPage() {
  const navigate = useNavigate();
  const [currency, setCurrency] = useState('eur');
  const [billing, setBilling] = useState('monthly');
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [videoOpen, setVideoOpen] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  // Theme
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Scroll
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  // ESC modal
  useEffect(() => {
    const fn = e => e.key === 'Escape' && setVideoOpen(false);
    window.addEventListener('keydown', fn);
    return () => window.removeEventListener('keydown', fn);
  }, []);

  // Scroll reveal
  useEffect(() => {
    const els = document.querySelectorAll('.lp-reveal');
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('lp-revealed'); io.unobserve(e.target); }
      });
    }, { threshold: 0.07 });
    els.forEach(el => io.observe(el));
    const t = setTimeout(() => els.forEach(el => el.classList.add('lp-revealed')), 2500);
    return () => { io.disconnect(); clearTimeout(t); };
  }, []);

  const go = id => { document.getElementById(id)?.scrollIntoView({behavior:'smooth'}); setMenuOpen(false); };

  return (
    <div className="lp" data-theme={theme}>

      {/* THEME TOGGLE */}
      <button className="lp-theme-btn" onClick={() => setTheme(t => t==='dark'?'light':'dark')} title="Toggle theme">
        {theme === 'dark' ? '☀️' : '🌙'}
      </button>

      {/* NAV */}
      <header className={`lp-nav ${scrolled?'lp-nav--solid':''}`}>
        <div className="lp-nav__inner">
          <div className="lp-nav__brand" onClick={() => window.scrollTo({top:0,behavior:'smooth'})}>
            <span className="lp-nav__hex">⬡</span>
            <span className="lp-nav__name">TaalumaERP</span>
          </div>
          <nav className="lp-nav__links">
            {[['features','Features'],['how','How it works'],['pricing','Pricing']].map(([id,l]) => (
              <button key={id} className="lp-nav__link" onClick={() => go(id)}>{l}</button>
            ))}
          </nav>
          <div className="lp-nav__actions">
            <button className="lp-nav__signin" onClick={() => navigate('/login')}>Sign in</button>
            <button className="lp-nav__start" onClick={() => navigate('/register')}>Start free trial</button>
          </div>
          <button className="lp-nav__burger" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <X size={20}/> : <Menu size={20}/>}
          </button>
        </div>
        {menuOpen && (
          <div className="lp-nav__mobile">
            {[['features','Features'],['how','How it works'],['pricing','Pricing']].map(([id,l]) => (
              <button key={id} onClick={() => go(id)}>{l}</button>
            ))}
            <hr/>
            <button onClick={() => navigate('/login')}>Sign in</button>
            <button className="primary" onClick={() => navigate('/register')}>Start free trial →</button>
          </div>
        )}
      </header>

      {/* HERO */}
      <section className="lp-hero">
        <div className="lp-hero__bg">
          <div className="lp-hero__orb-a"></div>
          <div className="lp-hero__orb-b"></div>
        </div>
        <div className="lp-hero__inner">
          <div className="lp-hero__copy">
            <div className="lp-hero__kicker">
              <span className="lp-hero__kicker-dot"></span>
              Inventory software for real business conditions
            </div>
            <h1 className="lp-hero__h1">
              <span className="lp-hero__h1-line">Your stock.</span>
              <span className="lp-hero__h1-line">Your orders.</span>
              <span className="lp-hero__h1-em">Works anywhere.</span>
            </h1>
            <p className="lp-hero__lead">
              TaalumaERP is built for businesses that operate across multiple
              warehouses, multiple countries, and inconsistent internet.
              It runs fully offline and syncs when you reconnect.
            </p>
            <div className="lp-hero__cta">
              <button className="lp-btn-accent lp-btn-accent--lg" onClick={() => navigate('/register')}>
                Start free 14-day trial <ArrowRight size={17}/>
              </button>
              <button className="lp-btn-ghost" onClick={() => setVideoOpen(true)}>
                <span className="lp-btn-ghost__icon"><Play size={12}/></span>
                See how it works
              </button>
            </div>
            <p className="lp-hero__subtext">No credit card required · Full access during trial · Cancel anytime</p>
          </div>

          <div className="lp-hero__visual">
            <div className="lp-ui-frame">
              <div className="lp-ui-frame__chrome">
                <span/><span/><span/>
                <div className="lp-ui-frame__url">app.taalumaerp.com/dashboard</div>
              </div>
              <div className="lp-ui-frame__body">
                <div className="lp-ui-sidebar">
                  {['Dashboard','Inventory','Orders','Customers','Warehouses','Reports','Team'].map((item,i) => (
                    <div key={i} className={`lp-ui-sidebar__item${i===0?' active':''}`}>{item}</div>
                  ))}
                </div>
                <div className="lp-ui-main">
                  <div className="lp-ui-topbar">
                    <span className="lp-ui-topbar__title">Dashboard</span>
                    <span className="lp-ui-offline"><WifiOff size={10}/>&nbsp;Offline</span>
                  </div>
                  <div className="lp-ui-cards">
                    {[
                      {l:'Products',v:'1,284',c:'#00d4aa'},
                      {l:'Orders today',v:'23',c:'#818cf8'},
                      {l:'Low stock',v:'8',c:'#f59e0b'},
                      {l:'Warehouses',v:'3',c:'#10b981'},
                    ].map((c,i) => (
                      <div key={i} className="lp-ui-card" style={{'--c':c.c}}>
                        <div className="lp-ui-card__v">{c.v}</div>
                        <div className="lp-ui-card__l">{c.l}</div>
                      </div>
                    ))}
                  </div>
                  <div className="lp-ui-chart">
                    <div className="lp-ui-chart__lbl">Revenue — last 7 days</div>
                    <div className="lp-ui-chart__bars">
                      {[55,72,48,85,63,91,78].map((h,i) => (
                        <div key={i} className="lp-ui-chart__wrap">
                          <div className="lp-ui-chart__bar" style={{height:`${h}%`,animationDelay:`${i*.07}s`}}/>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="lp-ui-stocks">
                    {[
                      {name:'Maize flour 2kg',qty:12,warn:true},
                      {name:'Sunflower oil 1L',qty:86},
                      {name:'Rice 5kg bag',qty:34},
                    ].map((s,i) => (
                      <div key={i} className={`lp-ui-stock${s.warn?' warn':''}`}>
                        {s.warn && <AlertCircle size={10}/>}
                        <span>{s.name}</span>
                        <span className="lp-ui-stock__qty">{s.qty}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="lp-chip lp-chip--a"><RefreshCw size={12}/> Synced just now</div>
            <div className="lp-chip lp-chip--b"><TrendingUp size={12}/> 3 warehouses active</div>
          </div>
        </div>
      </section>

      {/* METRICS BAND */}
      <div className="lp-metrics lp-reveal">
        <div className="lp-metrics__inner">
          {METRICS.map((m,i) => (
            <div key={i} className="lp-metric">
              <div className="lp-metric__val">{m.val}</div>
              <div className="lp-metric__label">{m.label}</div>
              <div className="lp-metric__sub">{m.sub}</div>
            </div>
          ))}
        </div>
      </div>

      {/* OFFLINE STRIP */}
      <div className="lp-strip lp-reveal">
        <div className="lp-strip__accent-line"></div>
        <div className="lp-strip__inner">
          <div className="lp-strip__icon-wrap"><WifiOff size={22}/></div>
          <div className="lp-strip__text">
            <h3>Built for places where internet isn't guaranteed.</h3>
            <p>Most inventory software breaks without a connection. TaalumaERP doesn't.
               Orders, stock updates, team access — everything works offline.
               It syncs automatically the moment you reconnect. No data loss. No exceptions.</p>
          </div>
          <div className="lp-strip__tags">
            <span className="lp-strip__tag">Power cuts</span>
            <span className="lp-strip__tag">Weak 3G</span>
            <span className="lp-strip__tag">Remote warehouses</span>
          </div>
        </div>
      </div>

      {/* FEATURES */}
      <section id="features" className="lp-features">
        <div className="lp-features__inner">
          <div className="lp-features__head lp-reveal">
            <div className="lp-eyebrow">Features</div>
            <h2 className="lp-h2">Built for how your business<br/><em>actually operates.</em></h2>
            <p className="lp-lead">
              No enterprise bloat. No features you'll never use.
              Just the tools to run inventory, orders, and your team — across borders.
            </p>
          </div>
          <div className="lp-feat-grid">
            {FEATURES.map((f,i) => (
              <div key={i} className={`lp-feat-card lp-reveal${f.featured?' lp-feat-card--featured':''}`}
                style={{transitionDelay:`${i*.07}s`}}>
                <div className="lp-feat-card__head">
                  <div className="lp-feat-card__icon">{f.icon}</div>
                  <span className="lp-feat-card__tag">{f.tag}</span>
                </div>
                <h3>{f.title}</h3>
                <p>{f.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section id="how" className="lp-how">
        <div className="lp-how__inner">
          <div className="lp-how__head lp-reveal">
            <div className="lp-eyebrow">Getting started</div>
            <h2 className="lp-h2">Operational in <em>under 15 minutes.</em></h2>
          </div>
          <div className="lp-how__steps">
            {[
              {n:'01',title:'Register your organization',body:'Takes 2 minutes. Set up your workspace, add your warehouses, invite your team.'},
              {n:'02',title:'Import or add your inventory',body:'Upload a CSV file or add products manually. Bulk import handles large catalogues.'},
              {n:'03',title:'Start managing from day one',body:'Create orders, track stock, assign to team members. Works online and offline from the first login.'},
            ].map((s,i) => (
              <div key={i} className="lp-how__step lp-reveal" style={{transitionDelay:`${i*.1}s`}}>
                <span className="lp-how__n">{s.n}</span>
                <h3>{s.title}</h3>
                <p>{s.body}</p>
                {i < 2 && <ChevronRight className="lp-how__arrow" size={20}/>}
              </div>
            ))}
          </div>
          <div className="lp-how__cta lp-reveal">
            <button className="lp-btn-accent lp-btn-accent--lg" onClick={() => navigate('/register')}>
              Create your workspace <ArrowRight size={17}/>
            </button>
            <p>14-day free trial. No credit card. Cancel anytime.</p>
          </div>
        </div>
      </section>

      {/* MARKET */}
      <section className="lp-market lp-reveal">
        <div className="lp-market__inner">
          <div className="lp-market__left">
            <div className="lp-eyebrow">Who it's for</div>
            <h2>Built for East African trade.<br/>Ready for European standards.</h2>
            <p>
              TaalumaERP was designed for businesses that source from East Africa and
              sell into Europe, or operate warehouses across both regions.
              Pricing in TZS, UGX, EUR and USD. Multi-currency reporting.
              Works in Dar es Salaam and Milan on the same account.
            </p>
          </div>
          <div className="lp-market__flags">
            {[
              {flag:'🇹🇿',country:'Tanzania'},
              {flag:'🇺🇬',country:'Uganda'},
              {flag:'🇰🇪',country:'Kenya'},
              {flag:'🇷🇼',country:'Rwanda'},
              {flag:'🇮🇹',country:'Italy'},
              {flag:'🇫🇷',country:'France'},
              {flag:'🇩🇪',country:'Germany'},
              {flag:'🇳🇱',country:'Netherlands'},
            ].map((m,i) => (
              <div key={i} className="lp-market__flag">
                <span>{m.flag}</span><span>{m.country}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="lp-pricing">
        <div className="lp-pricing__inner">
          <div className="lp-pricing__head lp-reveal">
            <div className="lp-eyebrow">Pricing</div>
            <h2 className="lp-h2">Simple, <em>transparent</em> pricing.</h2>
            <p className="lp-lead">
              One price. All features included. No per-user fees beyond your plan limit.
              Pay monthly or once — your choice.
            </p>
          </div>
          <div className="lp-pricing__controls lp-reveal">
            <div className="lp-pricing__billing">
              {[['monthly','Monthly'],['onetime','One-time payment']].map(([k,l]) => (
                <button key={k} className={`lp-pricing__bill-btn${billing===k?' active':''}`}
                  onClick={() => setBilling(k)}>{l}</button>
              ))}
            </div>
            <div className="lp-pricing__curs">
              {CURRENCIES.map(c => (
                <button key={c.key} className={`lp-pricing__cur${currency===c.key?' active':''}`}
                  onClick={() => setCurrency(c.key)}>{c.flag} {c.label}</button>
              ))}
            </div>
          </div>
          <div className="lp-pricing__cards">
            {PLANS.map((plan,i) => (
              <div key={plan.key}
                className={`lp-pricing-card lp-reveal${plan.popular?' lp-pricing-card--pop':''}`}
                style={{transitionDelay:`${i*.08}s`}}>
                {plan.popular && <div className="lp-pricing-card__badge">Most popular</div>}
                <div className="lp-pricing-card__name">{plan.name}</div>
                <div className="lp-pricing-card__limits">{plan.limits}</div>
                <div className="lp-pricing-card__price">
                  <span className="lp-pricing-card__amount">
                    {fmt(billing==='monthly'?plan.price[currency]:plan.onetime[currency], currency)}
                  </span>
                  <span className="lp-pricing-card__per">
                    {billing==='monthly'?' / month':' one-time'}
                  </span>
                </div>
                {billing==='monthly' && (
                  <p className="lp-pricing-card__alt">
                    or {fmt(plan.onetime[currency],currency)} one-time
                  </p>
                )}
                <ul className="lp-pricing-card__features">
                  {plan.features.map((f,j) => (
                    <li key={j}><Check size={14}/>{f}</li>
                  ))}
                </ul>
                <button
                  className={`lp-pricing-card__btn${plan.popular?' accent':''}`}
                  onClick={() => navigate('/register')}>
                  Start free trial
                </button>
              </div>
            ))}
          </div>
          <div className="lp-pricing__note lp-reveal">
            <Lock size={13}/>
            All plans start with a <strong>14-day free trial</strong> with full access.
            No credit card required. You choose a plan at the end of your trial.
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="lp-cta lp-reveal">
        <div className="lp-cta__glow"></div>
        <div className="lp-cta__inner">
          <h2>Stop managing inventory<br/>in spreadsheets.</h2>
          <p>
            If your business runs across warehouses, borders, or unreliable internet —
            TaalumaERP was built for exactly that.
            Try it free for 14 days and see if it fits.
          </p>
          <button className="lp-btn-accent lp-btn-accent--lg" onClick={() => navigate('/register')}>
            Get started free <ArrowRight size={18}/>
          </button>
          <p className="lp-cta__note">No credit card · Full access · Cancel anytime</p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="lp-footer">
        <div className="lp-footer__inner">
          <div className="lp-footer__brand">
            <span className="lp-footer__logo">⬡ TaalumaERP</span>
            <p>Inventory management that works everywhere.<br/>Built for Africa. Ready for Europe.</p>
          </div>
          <div className="lp-footer__links">
            <a href="/terms">Terms</a>
            <a href="/privacy">Privacy</a>
            <a href="mailto:support@taalumaerp.com">Contact</a>
          </div>
          <p className="lp-footer__copy">© 2025 TaalumaERP · Modena, Italy</p>
        </div>
      </footer>

      {/* VIDEO MODAL */}
      {videoOpen && (
        <div className="lp-modal-overlay" onClick={() => setVideoOpen(false)}>
          <div className="lp-modal" onClick={e => e.stopPropagation()}>
            <button className="lp-modal__close" onClick={() => setVideoOpen(false)}><X size={18}/></button>
            <div className="lp-modal__body">
              <Play size={44}/>
              <p>Demo video coming soon.</p>
              <button className="lp-btn-accent" onClick={() => {setVideoOpen(false);navigate('/register')}}>
                Try it yourself → free 14-day trial
              </button>
            </div>
          </div>
        </div>
      )}

      <ChatBot theme={theme} />
    </div>
  );
}